<template>
  <panel :is-loading="isLoading" class="dlp-stores-list panel w-[425px] min-w-[425px] bp768:min-w-full text-charcoal">
    <template v-if="!isLoading" #title>
      {{ dlpList.length }} {{ dlpList.length > 1 ? 'magasins' : 'magasin' }} en
      {{ filteredIdRegion ? dlpRegionList.find(region => region.id === filteredIdRegion)?.name : 'France' }}
    </template>

    <template
      v-if="dlpRegionList.length > 1 || $mq.bp768"
      #header>
      <div class="flex gap-3 items-center justify-center flex-wrap bp768:flex-nowrap">
        <template v-if="dlpRegionList.length > 1 && !$mq.bp768">
          <potager-button
            :theme="filteredIdRegion === null ? 'charcoal' : 'white'"
            isRounded
            @onClick="onFilterRegion">
            Tous
          </potager-button>

          <potager-button
            v-for="(region, index) in dlpRegionList"
            :key="index"
            :theme="filteredIdRegion === region.id ? 'charcoal' : 'white'"
            isRounded
            @onClick="onFilterRegion(region.id)">
            {{ region.name }}
          </potager-button>
        </template>

        <template v-else>
          <template v-if="dlpRegionList.length > 1">
                  <span class="text-xs font-semibold">
                    Filtres&nbsp;:
                  </span>

            <potager-input
              v-model="filteredIdRegion"
              :options="dlpRegionList.map(region => ({
                    label: region.name,
                    value: region.id,
                  }))"
              full-width
              placeholder="Région"
              type="select" />
          </template>

          <dlp-list-switcher class="mt-0" />
        </template>
      </div>
    </template>

    <div class="panel-section--transparent">
      <dlp-store-card
        v-for="(deliveryPoint, index) in dlpList?.slice(0, dlpPerPage * page)"
        :key="index"
        :ref="`dlpStoreCard-${deliveryPoint.id}`"
        :delivery-point="deliveryPoint"
        @onSelect="TOGGLE_LIST_VISIBILITY" />

      <div
        v-intersect="onBottom"
        class="bottom-trigger h-1 w-full" />
    </div>
  </panel>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { TOGGLE_LIST_VISIBILITY } from 'Stores/types/mapMutationsTypes';

import DlpStoreCard from 'Components/deliveryPoint/DlpStoreCard';
import DlpListSwitcher from 'Components/deliveryPoint/DlpListSwitcher';

import PotagerButton from 'UI/PotagerButton';
import PotagerInput from 'UI/Form/PotagerInput';

import { REGION_ID_MAPPING } from 'Classes/Constants';

import WoosMapMixin from 'Mixins/WoosMapMixin';
import Panel from 'Components/panel/Panel.vue';

export default {
  components: {
    Panel,
    PotagerInput,
    DlpListSwitcher,
    PotagerButton,
    DlpStoreCard
  },

  mixins: [
    WoosMapMixin,
  ],

  emits: [
    'onSelect',
  ],

  data() {
    return {
      dlpPerPage: 10,
      page: 1,
      filteredIdRegion: null,
    };
  },

  watch: {
    getMapPublicSearchResult: {
      handler(dlpList) {
        if (dlpList.length > 0 && dlpList[0].regionId !== this.filteredIdRegion) {
          this.filteredIdRegion = null;
        }

        const closestScrollElement = document.querySelector('[data-scroll="true"]'); // get the panel scroll element
        if (closestScrollElement) {
          closestScrollElement.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters('map', [
      'getMapPublicSearchResult',
      'getSelectedDeliveryPoint',
    ]),
    dlpRegionList() {
      // WARNING : getMapPublicSearchResult is limited to 300 results, so this can lead to unexpected results (missing regions)
      const regionIdList = this.getMapPublicSearchResult
        .map((dlp) => dlp.regionId)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort((a, b) => a - b);
      return regionIdList.map((regionId) => REGION_ID_MAPPING[regionId]);
    },
    dlpList() {
      const dlps = this.getMapPublicSearchResult
        .filter((dlp) => !this.filteredIdRegion || dlp.regionId === this.filteredIdRegion);
      const total = this.dlps?.length || 0;
      const max = this.dlpPerPage * this.page;
      return total > max
        ? dlps.slice(0, max)
        : dlps;
    },
    isLoading() {
      return this.dlpList.length === 0;
    },
  },

  methods: {
    ...mapMutations('map', [
      TOGGLE_LIST_VISIBILITY,
    ]),
    onBottom(isVisible) {
      if (isVisible && !this.isLoading && this.page * this.dlpPerPage < this.getMapPublicSearchResult.length) {
        this.page += 1;
      }
    },
    onFilterRegion(regionId) {
      this.filteredIdRegion = regionId || null;
      this.page = 1;

      this.UPDATE_SELECTED_DELIVERY_POINT(null);
      this.boundDlpS(regionId ? { regionId } : { all: true });
    },
  },
};
</script>
